if (!customElements.get("rotating-banner")) {
  customElements.define(
    "rotating-banner",
    class RotatingBanner extends HTMLElement {
      constructor() {
        super();
        this.elements = {}; // Initialize the elements object
      }

      connectedCallback() {
        Marquee3k.init({
          selector: "rotating-banner__banner" // define a custom class name
        });

        // Add event listeners for mouseenter and mouseleave
        this.addEventListener("mouseenter", this.handleMouseEnter);
        this.addEventListener("mouseleave", this.handleMouseLeave);
      }

      handleMouseEnter() {
        // Pause all Marquee3k instances on mouseenter
        Marquee3k.pauseAll();
      }

      handleMouseLeave() {
        // Resume all Marquee3k instances on mouseleave
        Marquee3k.playAll();
      }
    }
  );
}
